

import React from 'react';
import { Input } from '@/components/ui/input';

interface JobTitleAutocompleteProps {
  value?: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export const JobTitleAutocomplete = ({
  value = '',
  onValueChange,
  placeholder = 'Enter job title...',
  disabled = false,
}: JobTitleAutocompleteProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onValueChange(e.target.value);
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

